import { jsx as r } from "react/jsx-runtime";
import { cn as t } from "@tameeni/shared-logic";
function a({
  className: e,
  ...o
}) {
  return /* @__PURE__ */ r(
    "div",
    {
      className: t("animate-pulse rounded bg-slate-200/50", e),
      ...o
    }
  );
}
export {
  a as Skeleton
};
